import { render, staticRenderFns } from "./CatalogoList.vue?vue&type=template&id=46e52fd9&scoped=true&lang=pug"
import script from "./CatalogoList.vue?vue&type=script&lang=js"
export * from "./CatalogoList.vue?vue&type=script&lang=js"
import style0 from "./CatalogoList.vue?vue&type=style&index=0&id=46e52fd9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e52fd9",
  null
  
)

export default component.exports